import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  Stack,
  Box,
  CircularProgress,
  Alert
} from '@mui/material';
import {
  Business as BusinessIcon,
  Route as RouteIcon,
  Devices as DevicesIcon
} from '@mui/icons-material';

const OrganizationOverview = ({ organizationData, loading, error }) => {
  if (loading) {
    return (
      <Paper sx={{ p: 3, borderRadius: 1, textAlign: 'center', mb: 3 }}>
        <CircularProgress size={24} />
        <Typography variant="body2" sx={{ mt: 1 }}>Loading...</Typography>
      </Paper>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mb: 3, borderRadius: 1 }}>
        {error}
      </Alert>
    );
  }

  if (!organizationData) {
    return null;
  }

  return (
    <Paper sx={{ p: 3, borderRadius: 1, mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
        <BusinessIcon fontSize="small" color="primary" />
        <Typography variant="h6" fontWeight={600}>
          Organization Context
        </Typography>
      </Stack>
      
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <BusinessIcon color="primary" />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                    {organizationData.organization.name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Organization
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <RouteIcon color="success" />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                    {organizationData.totalNetworks} Networks
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Active networks
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Card variant="outlined" sx={{ height: '100%', borderRadius: 1 }}>
            <CardContent sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <DevicesIcon color="info" />
                <Box sx={{ minWidth: 0, flex: 1 }}>
                  <Typography variant="subtitle2" fontWeight={600} sx={{ mb: 0.5 }}>
                    {organizationData.totalDevices} Devices
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    Registered devices
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default OrganizationOverview; 